import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { FieldTypeEnum } from '@models/module/fields/enums';
import { FormFieldModel } from '@models/module/fields/main';
import { TableFieldViewComponent } from '@module-definition/table-field/table-field-view/table-field-view.component';
import { CipoTextViewComponent } from '@shared/components/fields/cipo-text-view/cipo-text-view.component';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { GridFormViewService } from '../common';

@Component({
  selector: 'cipo-grid-form-view',
  imports: [CipoTextViewComponent, FroalaComponent, TableFieldViewComponent],
  templateUrl: './grid-form-view.component.html',
  styleUrls: ['../grid-form/grid-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFormViewComponent {
  private gridFormViewService = inject(GridFormViewService);
  FIELD_TYPES = FieldTypeEnum;

  includeHistory = input<boolean>(false);
  fields = input<FormFieldModel[]>([]);
  entityInstanceId = input<number>(null);
  actionInstanceId = input<number>(null);

  mappedFields = computed(() => {
    return this.fields().map(field => {
      const { config, value, readonlyConfig } = this.gridFormViewService.getTextViewConfig(
        field,
        this.includeHistory(),
      );
      config.entityInstanceId = this.entityInstanceId();
      config.actionInstanceId = this.actionInstanceId();
      return {
        baseField: field,
        config,
        value,
        readonlyConfig,
      };
    });
  });
}
